export const getRelativeDate = (offset = 0) => new Date(Date.now() + offset)
